/** Transient messages. Errors say what happened and what to do about it. */
import { ApiError, isOpaqueError } from '../core/api';
import { el } from './dom';

let host: HTMLElement | undefined;

function container(): HTMLElement {
  if (!host || !host.isConnected) {
    host = el('div', { class: 'toasts', role: 'status', 'aria-live': 'polite' });
    document.body.appendChild(host);
  }
  return host;
}

export function toast(message: string, kind: 'info' | 'error' = 'info', ms = 5000): void {
  const node = el(
    'div',
    { class: kind === 'error' ? 'toast toast--error' : 'toast' },
    el('span', { text: message }),
  );
  const close = el('button', {
    class: 'toast__close',
    type: 'button',
    'aria-label': 'Dismiss',
    text: '×',
    onClick: () => node.remove(),
  });
  node.appendChild(close);
  container().appendChild(node);
  setTimeout(() => node.remove(), ms);
}

export const GENERIC_FAILURE = 'Something went wrong. Try again.';

/**
 * Turns any thrown value into a sentence a person can act on. `fallback` is
 * what to say when the server would only have said "Internal error" — pass the
 * one that names what was being attempted.
 */
export function errorMessage(err: unknown, fallback = GENERIC_FAILURE): string {
  if (err instanceof ApiError) {
    if (err.code === 'RATE_LIMITED' && err.retryAfter) {
      return `${err.message} Try again in ${Math.ceil(err.retryAfter)}s.`;
    }
    if (isOpaqueError(err)) return fallback;
    return err.message || fallback;
  }
  if (err instanceof Error) return err.message || fallback;
  return fallback;
}

export function toastError(err: unknown, fallback?: string): void {
  toast(errorMessage(err, fallback), 'error', 7000);
}
